import { render, staticRenderFns } from "./TransferTransactionForm.vue?vue&type=template&id=a35f5630&scoped=true&"
import script from "./TransferTransactionForm.vue?vue&type=script&lang=js&"
export * from "./TransferTransactionForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferTransactionForm.vue?vue&type=style&index=0&id=a35f5630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35f5630",
  null
  
)

export default component.exports